module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/master/office/office.component.html
// module id = ./src/app/master/office/office.component.html
// module chunks = main